<template>
    <div class="layui-layer-content" style="display: none">
        <div >
            <div class="layui-card-header">配色方案</div>
            <div class="layui-card-body layadmin-setTheme">
                <ul class="layadmin-setTheme-color">
                <li layadmin-event="setTheme" data-index="0" data-alias="default" title="default">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #20222A;">
                    <div class="layadmin-setTheme-logo" style="background-color: undefined;">
                    </div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="1" data-alias="dark-blue" title="dark-blue">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #03152A;">
                    <div class="layadmin-setTheme-logo" style="background-color: undefined;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="2" data-alias="coffee" title="coffee">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #2E241B;">
                    <div class="layadmin-setTheme-logo" style="background-color: undefined;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="3" data-alias="purple-red" title="purple-red">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #50314F;">
                    <div class="layadmin-setTheme-logo" style="background-color: undefined;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="4" data-alias="ocean" title="ocean">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #344058;">
                    <div class="layadmin-setTheme-logo" style="background-color: #1E9FFF;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="5" data-alias="green" title="green">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #3A3D49;">
                    <div class="layadmin-setTheme-logo" style="background-color: #2F9688;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="6" data-alias="red" title="red">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #20222A;">
                    <div class="layadmin-setTheme-logo" style="background-color: #F78400;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="7" data-alias="fashion-red" title="fashion-red">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #28333E;">
                    <div class="layadmin-setTheme-logo" style="background-color: #AA3130;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="8" data-alias="classic-black" title="classic-black">
                    <div class="layadmin-setTheme-header" style="background-color: undefined;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #24262F;">
                    <div class="layadmin-setTheme-logo" style="background-color: #3A3D49;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="9" data-alias="green-header" title="green-header">
                    <div class="layadmin-setTheme-header" style="background-color: #2F9688;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: undefined;">
                    <div class="layadmin-setTheme-logo" style="background-color: #226A62;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="10" data-alias="ocean-header" title="ocean-header">
                    <div class="layadmin-setTheme-header" style="background-color: #1E9FFF;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #344058;">
                    <div class="layadmin-setTheme-logo" style="background-color: #0085E8;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="11" data-alias="classic-black-header" title="classic-black-header">
                    <div class="layadmin-setTheme-header" style="background-color: #393D49;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: undefined;">
                    <div class="layadmin-setTheme-logo" style="background-color: undefined;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="12" data-alias="purple-red-header" title="purple-red-header">
                    <div class="layadmin-setTheme-header" style="background-color: #50314F;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #50314F;">
                    <div class="layadmin-setTheme-logo" style="background-color: #50314F;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="13" data-alias="fashion-red-header" title="fashion-red-header">
                    <div class="layadmin-setTheme-header" style="background-color: #AA3130;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #28333E;">
                    <div class="layadmin-setTheme-logo" style="background-color: #28333E;"></div>
                    </div>
                </li>
                <li layadmin-event="setTheme" data-index="14" data-alias="green-header" title="green-header">
                    <div class="layadmin-setTheme-header" style="background-color: #009688;"></div>
                    <div class="layadmin-setTheme-side" style="background-color: #28333E;">
                    <div class="layadmin-setTheme-logo" style="background-color: #009688;"></div>
                    </div>
                </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name : 'LayuiTheme',
    data() {
        return {
            id: null,
        }
    },
    mounted() {
        var element = this.el = $(this.$el);
        var id = this.id =  this.uuid();
        element.attr('id', id);
    },
    methods: {
        show() {
            var element = this.el = $(this.$el);
            if(element.is(':visible')) {
                this.layer.closePop(this.id);
            } else {
                this.layer.openPopRight(this.id, '300px');
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/LayuiTheme.vue